// Autogenerated file
export const classificationDirectionsEnum = {
    CargoTransportation: "CargoTransportation",
    Warehousing: "Warehousing",
    CustomsClearance: "CustomsClearance",
    FreightForwarding: "FreightForwarding",
    Insurance: "Insurance",
    LoadingUnloading: "LoadingUnloading",
    CourierDelivery: "CourierDelivery",
    Packaging: "Packaging",
    StorageRent: "StorageRent",
    DangerousGoodsHandling: "DangerousGoodsHandling",
};
export const classificationDirections = [
    { label: "Перевозка груза", value: "CargoTransportation" },
    { label: "Складские услуги", value: "Warehousing" },
    { label: "Таможенное оформление", value: "CustomsClearance" },
    { label: "Экспедирование", value: "FreightForwarding" },
    { label: "Страхование груза", value: "Insurance" },
    { label: "Погрузо-разгрузочные работы", value: "LoadingUnloading" },
    { label: "Курьерская доставка", value: "CourierDelivery" },
    { label: "Упаковка", value: "Packaging" },
    { label: "Аренда складских помещений", value: "StorageRent" },
    { label: "Работа с опасными грузами", value: "DangerousGoodsHandling" },
];
